import React, { Component } from 'react';
import './../../assets/css/App.css';
import Cookies from 'js-cookie';
import apiConfig from '../../config/config';

class Header extends Component {
    logOut = () => {
        Cookies.remove('management_auth_token');
        Cookies.remove('management_account_id');
        window.location = "/";
    };

    handleAppSwitch = (url) => {
        window.location.href = url;
    }

    render() {
        // Get console URL from central config
        const consoleUrl = apiConfig.STACKRY_CONSOLE_URL;
        const logoUrl = "https://assets.stackry.com/Logo/stackrylogo-familiar-white.svg";

        return (
            <div className="page-header navbar navbar-fixed-top">
                <div className="page-header-inner">
                    <div className="page-logo">
                        <a>
                            <img src={logoUrl} alt="Stackry" className="logo-default"/>
                        </a>
                    </div>
                    <div className="top-menu">
                        <ul className="nav navbar-nav pull-right">
                            <li style={{color: '#fff', padding: '15px', fontSize: '13px'}}>
                                Currently in: <strong>📊 Reporting</strong>
                            </li>
                            <li>
                                <a onClick={() => this.handleAppSwitch(consoleUrl)} href="#" className="header-logout" style={{color: '#fff'}}>
                                    <i className="fa fa-cogs"></i> 🏢 Switch to Console
                                </a>
                            </li>
                            <li>
                                <a onClick={this.logOut} className="header-logout" style={{cursor: 'pointer', color: '#fff'}}>
                                    <i className="fa fa-key"></i> Log Out
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;
